<div *ngIf="!!userMetricGroup" class="columnFlexContent">
  <dx-radio-group
    (valueChange)="userMetricGroup.selectedDateSettings = $event;  checkForBucketsMax(); dateIsValid.emit(true)"
    [(value)]="userMetricGroup.selectedDateSettings"
    [items]="typeOfDateSettings"
    layout="horizontal">
    <div *dxTemplate="let dateSetting of 'item'">
      <div>{{ 'DATE_SELECTION.' + dateSetting + ".TITLE" | translate }}</div>
    </div>
  </dx-radio-group>
  <div *ngIf="userMetricGroup.selectedDateSettings === TypeOfDateSettingsEnum.FIXED_DATE"
       [ngClass]="(appService.isMobileScreen()) ? 'columnFlexContent' : 'rowFlexContent'">
    <dx-date-box
      (valueChange)="userMetricGroup.startDate = $event; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup.startDate"
      label="{{'DATE_SELECTION.FIXED_DATE.START_DATE_LABEL' | translate}}"
      style="flex: 1 1"
      type="datetime">
      <dx-validator [validationGroup]="'fromDate'">
        <dxi-validation-rule
          type="required"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
    <dx-date-box
      (valueChange)="userMetricGroup.endDate = $event; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup.endDate"
      label="{{'DATE_SELECTION.FIXED_DATE.END_DATE_LABEL' | translate}}"
      style="flex: 1 1"
      type="datetime">
    </dx-date-box>
  </div>

  <div *ngIf="userMetricGroup.selectedDateSettings === TypeOfDateSettingsEnum.REALTIME"
       class="rowFlexContent">

    <!-- ******************************** -->
    <!-- Real Time Settings               -->
    <!-- ******************************** -->

    <!-- ******************************** -->
    <!-- Time Value                       -->
    <!-- ******************************** -->

    <dx-number-box
      (onValueChanged)="userMetricGroup.realtimeValue = $event.value; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup.realtimeValue"
      [max]="9999"
      [min]="1"
      [showSpinButtons]="true"
      [step]="1"
      label="{{ 'DATE_SELECTION.REALTIME.TIME_VALUE' | translate }}"
      style="flex: 1 1">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dx-number-box>

    <!-- ******************************** -->
    <!-- Time Units                       -->
    <!-- ******************************** -->

    <dx-select-box
      (onValueChanged)="userMetricGroup.realTimeUnit = $event.value; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup.realTimeUnit"
      [dataSource]="telemetrySearchUnitValues"
      [displayExpr]="getAcquisitionCronLabel"
      [width]="'100%'"
      label="{{ 'DATE_SELECTION.REALTIME.TIME_UNIT' | translate }}"
      style="flex: 2 1">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dx-select-box>
  </div>

  <div class="rowFlexContent"
       style="margin-top: 10px;">
    <dx-number-box
      (onValueChanged)="userMetricGroup.bucketValue = $event.value; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup!.bucketValue!"
      [min]="1"
      [showSpinButtons]="true"
      [step]="1"
      label="{{'CHART_CREATION.BUCKET_VALUE' | translate}}"
      style="flex: 1 1">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dx-number-box>
    <dx-select-box
      (onValueChanged)="userMetricGroup.bucketUnits = $event.value; checkForBucketsMax(); dateIsValid.emit(true)"
      [value]="userMetricGroup!.bucketUnits!"
      [displayExpr]="getAcquisitionCronLabel"
      [items]="telemetryBucketUnitValues"
      label=" "
      style="flex: 1 1">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dx-select-box>
  </div>

  <span *ngIf="!localBucketIsValid || !errorMsg ||errorMsg.length>0 "
        style="color: var(--dx-color-danger)">{{ errorMsg }}</span>
</div>
